import { createSlice } from '@reduxjs/toolkit';
import { SurveyState } from './mifid-survey-types';
import {
  getAmlAnswersForMifid,
  getMifidAnswers,
  getMifidTemplate,
  registerMifid,
  saveMifidV2Full,
  updateStatusQuestionnaires,
} from './mifid-survey-thunk';

const initialState: SurveyState = {
  status: 'idle',
  error: false,
  surveyAnswers: undefined,
  amlAnswers: undefined,
  surveyTemplate: undefined,
  saveResponseStatus: 'idle',
  updateQuestionnairesStatus: 'idle',
  registerMifidStatus: 'idle',
};

const mifidSurveySlice = createSlice({
  name: 'features/mifidSurvey',
  initialState,
  reducers: {
    resetMifidSurvey() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMifidTemplate.fulfilled, (state, action) => {
      state.surveyTemplate = action.payload;
      state.status = 'succeeded';
    });
    builder.addCase(getMifidTemplate.pending, (state) => {
      state.surveyTemplate = undefined;
      state.status = 'loading';
    });
    builder.addCase(getMifidTemplate.rejected, (state) => {
      state.surveyTemplate = undefined;
      state.status = 'failed';
    });
    builder.addCase(getMifidAnswers.fulfilled, (state, action) => {
      state.surveyAnswers = action.payload;
      state.status = 'succeeded';
    });
    builder.addCase(getMifidAnswers.pending, (state) => {
      state.surveyAnswers = undefined;
      state.status = 'loading';
    });
    builder.addCase(getMifidAnswers.rejected, (state) => {
      state.surveyAnswers = undefined;
      state.status = 'failed';
    });
    builder.addCase(getAmlAnswersForMifid.fulfilled, (state, action) => {
      state.amlAnswers = action.payload;
    });
    builder.addCase(getAmlAnswersForMifid.pending, (state) => {
      state.amlAnswers = undefined;
    });
    builder.addCase(getAmlAnswersForMifid.rejected, (state) => {
      state.amlAnswers = undefined;
    });
    builder.addCase(saveMifidV2Full.fulfilled, (state, action) => {
      state.saveResponseStatus =
        action.payload?.code === '0' ? 'succeeded' : 'failed';
    });
    builder.addCase(saveMifidV2Full.pending, (state) => {
      state.saveResponseStatus = 'loading';
    });
    builder.addCase(saveMifidV2Full.rejected, (state) => {
      state.saveResponseStatus = 'failed';
    });
    builder.addCase(updateStatusQuestionnaires.fulfilled, (state) => {
      state.updateQuestionnairesStatus = 'succeeded';
    });
    builder.addCase(updateStatusQuestionnaires.pending, (state) => {
      state.updateQuestionnairesStatus = 'loading';
    });
    builder.addCase(updateStatusQuestionnaires.rejected, (state) => {
      state.updateQuestionnairesStatus = 'failed';
    });
    builder.addCase(registerMifid.pending, (state) => {
      state.registerMifidStatus = 'loading';
    });
    builder.addCase(registerMifid.fulfilled, (state) => {
      state.registerMifidStatus = 'succeeded';
    });
    builder.addCase(registerMifid.rejected, (state) => {
      state.registerMifidStatus = 'failed';
    });
  },
});

export const { resetMifidSurvey } = mifidSurveySlice.actions;

export default mifidSurveySlice.reducer;
